const Footer = () => {
  return (
    <footer className="bg-[#dbdbdb] py-8 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-4">
          <div className="text-xl font-bold text-orange-400 mb-2">
            <img
              className="inline"
              src="/images/mykeepin-logo.png"
              width={148}
              height={20}
              alt="mykeepin-logo"
            />
          </div>
          <p className="text-sm text-gray-600 mb-2">
            MYKEEPiN 서비스는 (주)씨피랩스에서 제공하는 무료서비스입니다.
          </p>
          <p className="text-xs text-gray-500 mb-1">
            대표이사 이종민 | 주소 경기도 성남시 수정구 창업로
          </p>
          <p className="text-xs text-gray-500 mb-1">46, 7층 B동 씨피랩스</p>
          <p className="text-xs text-gray-500 mb-4">
            고객지원 support@mykeepin.com
          </p>
        </div>
        <div className="border-t border-gray-300 pt-4">
          <p className="text-xs text-gray-400">
            Copyright © CPLABS Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
